console.log('js/cleanDescription.js -> v0.1.0');

$(() => {
	$('.js-listing-availability').find('*').filter(function () {
		var html = $.trim($(this).html());

		return html === '&nbsp;';
	}).addClass('hide');
})
